"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var Link_1 = require("./Link");

exports.routes = [];

exports.Routes = function () {
  return react_1.default.createElement(Link_1.Switch, null, exports.routes.map(function (_a) {
    var path = _a.path,
        Component = _a.component,
        exact = _a.exact;
    return react_1.default.createElement(Link_1.Route, {
      path: path,
      component: Component,
      exact: exact
    });
  }));
};